import { useEffect } from 'react';

export const useHotkeys = (keyMap) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            const isCtrl = e.ctrlKey || e.metaKey;
            const key = e.key.toLowerCase();
            for (const [combo, action] of Object.entries(keyMap)) {
                if (combo === 'ctrl+' + key && isCtrl) {
                    e.preventDefault();
                    action();
                } else if (combo === 'esc' && key === 'escape') {
                    action();
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [keyMap]);
};